import { Controller, Control, Path, FieldValues } from 'react-hook-form'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

import { CircularProgress } from '@mui/material'

interface AutocompleteFieldProps<
  O extends { id: string | number; label: string },
  TField extends FieldValues
> {
  control: Control<TField>
  name: Path<TField>
  options: O[]
  placeholder?: string
  isLoading?: boolean
  disabled?: boolean
  className?: string
}

export const AutocompleteFieldWithObject = <
  O extends { id: number | string; label: string },
  TField extends FieldValues
>(
  props: AutocompleteFieldProps<O, TField>
) => {
  const { control, options, name, isLoading = false, disabled, className } = props

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: 'Campo obrigatório'
      }}
      render={({ field, fieldState: { error } }) => {
        const { onChange, value, ref } = field
        return (
          <>
            <Autocomplete
              className={className}
              fullWidth
              disabled={disabled}
              value={
                value
                  ? options.find((option) => {
                      return value === option.id
                    }) ?? null
                  : null
              }
              getOptionLabel={(option) => {
                return option.label
              }}
              onChange={(event, newValue) => {
                onChange(newValue ? newValue.id : null)
              }}
              options={options}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={error ? true : false}
                  helperText={error?.message ?? ''}
                  label={props.placeholder}
                  inputRef={ref}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {isLoading ? <CircularProgress size={20} color="inherit" /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    )
                  }}
                />
              )}
            />
          </>
        )
      }}
    />
  )
}
